import { configureStore } from '@reduxjs/toolkit'

import studentSlice from '../features/student/studentSlice'
import createOrderReducer from '../features/payment/payment.order.slice'
import loginSlice from '../features/login/loginSlice'
import templateSlice from '../features/template/templateSlice'
import audioAndVideoSlice from '../features/audioAndVideoFiles/audioAndVideoSlice'

export default configureStore({
  reducer: {
    student: studentSlice,
    createOrder: createOrderReducer,
    login: loginSlice,
    template: templateSlice,
    audioAndVideo: audioAndVideoSlice
  }
})